<template>
    <div>
        <MercenaryHeader :title="'결제 내역'" :back-title="'활동 및 설정'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="flex: 1; background-color: #f5f5f5; overflow: hidden; padding-bottom: 20px;">
            <InfinityScroll style="height: 100%;" :is-enable-next-page-handle="isEnableNextPageHandle" :handle-next-page="handleNextPage" :refresh-action="refresh">
                <div style="padding: 0 12px;">
                    <div style="margin-top: 20px; font-weight: 500;">결제내역</div>
                    <div v-for="date, i in paymentList" :key="i" style="margin-top: 12px;">
                        <div style="margin-left: 12px; font-weight: 700; font-size: 12px; color: #606060; line-height: 24px; margin-bottom: 4px;">{{ transDate(date[0].sale_date) }}</div>
                        <div @click="showDetails(detail)" v-for="detail, i in date" :key="i + 'detail'" style="display: flex; margin-bottom: 12px;">
                            <div style="flex: 1; background-color: #fff; border-radius: 12px; padding: 12px;">
                                <div style="display: flex; justify-content: space-between; border-bottom: 1px solid #ededed; padding-bottom: 8px; align-items: center;">
                                    <div style="font-size: 14px; font-weight: 500; line-height: 24px;">{{ detail.contents_display }}</div>
                                    <div>
                                        <img :src="require('@/assets/images/mypage/ico-move.png')" style="width:10px;">
                                    </div>
                                </div>
                                <div style="display: flex; justify-content: space-between; align-items: center; padding-top: 8px;">
                                    <div style="line-height: 24px; font-weight: 500; font-size: 14px;">결제금액</div>
                                    <div style="line-height: 24px; font-weight: 700; font-size: 14px;">{{ detail.settle_price | comma }}원</div>
                                </div>
                            </div>
                            <div></div>
                        </div>
                    </div>
                </div>
            </InfinityScroll>
        </div>
    </div>
</template>

<script>
import MercenaryHeader from "@/components/common/MercenaryHeader";
import InfinityScroll from "@/components/common/InfinityScroll"

export default {
    name: "Payment",
    components: { MercenaryHeader, InfinityScroll },
    data() {
        return {
            paymentList: {},
            isEnableNextPageHandle: true,
            page: 1,
            dateList: []
        }
    },
    methods: {
        showDetails(payInfo) {
            this.$GlobalStore.addModal('PaymentDetail', { payInfo: payInfo })
        },
        refresh() {
            this.page = 1
            this.paymentList = {}
            this.getPaymentList()
        },
        handleNextPage() {
            this.page++
            this.getPaymentList()
        },
        formatDate(dateStr) {
            const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' };
            return new Date(dateStr).toLocaleDateString('ko-KR', options);
        },
        async getPaymentList() {
            this.isEnableNextPageHandle = false;
            const parameters = {}
            parameters.is_date_grouped = true
            parameters.page = this.page

            const res = await this.$Axios.get('/api/pay/my/list', { params: parameters })

            const result = res.data.payments

            if (Object.keys(result).length > 0) {
                this.isEnableNextPageHandle = true;

                if (Object.keys(this.paymentList).length === 0) {
                    this.paymentList = result
                } else {
                    Object.keys(result).forEach((item) => {
                        if (Object.keys(this.paymentList).includes(item)) {
                            this.paymentList[item].push(...result[item])
                        } else {
                            this.paymentList[item] = result[item]
                        }
                    })
                }
            }
        },
        transDate(date) {
            let transDate = date.split('-')
            const year = transDate[0]
            const month = transDate[1]
            const day = transDate[2]

            return `${year}년 ${month}월 ${day}일`
        }
    },
    created() {
        this.getPaymentList()
    }

}
</script>

<style scoped>
.card-list {
    background-color: white;
    border-radius: 12px;
}

.card-list+.card-list {
    margin-top: 8px;
}
</style>